import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users, UserRound, Building2, Briefcase, FileText, Gift, Loader2 } from "lucide-react";
import { getAdminAuthHeaders } from "./AdminAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CARDS = [
  { key: "users_total", label: "Usuarios totales", icon: Users, color: "text-[#028CF8]" },
  { key: "candidates_total", label: "Candidatos", icon: UserRound, color: "text-emerald-600" },
  { key: "companies_total", label: "Empresas totales", icon: Building2, color: "text-slate-700" },
  { key: "employers_total", label: "Empresas (usuarios)", icon: Building2, color: "text-purple-600" },
  { key: "jobs_active", label: "Empleos activos", icon: Briefcase, color: "text-amber-600" },
  { key: "applications_total", label: "Aplicaciones", icon: FileText, color: "text-pink-600" },
  { key: "trials_active", label: "Trials / accesos manuales activos", icon: Gift, color: "text-indigo-600" },
];

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/admin/dashboard/stats`, { headers: getAdminAuthHeaders() })
      .then((res) => setStats(res.data))
      .catch(() => setError("No se pudieron cargar las estadísticas."));
  }, []);

  return (
    <div data-testid="admin-dashboard-page">
      <h1 className="text-xl font-bold text-slate-900 mb-1">Dashboard</h1>
      <p className="text-sm text-slate-500 mb-6">Estado general de la plataforma</p>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {!stats && !error && (
        <div className="flex items-center justify-center py-16"><Loader2 className="h-6 w-6 text-[#028CF8] animate-spin" /></div>
      )}
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-testid="admin-dashboard-cards">
          {CARDS.map(({ key, label, icon: Icon, color }) => (
            <div key={key} data-testid={`admin-stat-${key}`} className="bg-white rounded-xl border border-slate-200 p-4 md:p-5 shadow-sm">
              <Icon className={`h-5 w-5 mb-2 ${color}`} />
              <p className="text-2xl font-bold text-slate-900">{stats[key]}</p>
              <p className="text-xs text-slate-500 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
